export enum Roles {
    ADMIN = 3,
    EDITOR = 2,
    VIEWER = 1,
    NONE = 0
}

export enum Pages {
    DASHBOARD = 'dashboard',
    POLICIES = 'policies',
    SERVICE_ACCOUNTS = 'serviceAccounts',
    CLOUD_NHI = 'cloudNhi',
    APPLICATIONS_DISCOVERY = 'applicationsDiscovery',
    ACCESS_ANALYSIS = 'accessAnalysis',
    INSIGHTS = 'insights',
    RISK = 'risk',
    LOGS = 'logs',
    SETTINGS = 'settings',
    USERS = 'users',
    SYSTEM_STATUS = 'systemStatus',
    NOTIFICATIONS = 'notifications',
    SOFTWARE_UPDATES = 'softwareUpdates',
    PRIVILEGED_ACCOUNTS = 'privilegedAccounts',
    INVENTORY = 'inventory'
}

export enum SettingsSubCategories {
    AUTHORIZE = 'authorize',
    TEST_USER_TOKENS = 'testUserTokens',
    CLOUD_INTEGRATIONS = 'cloudIntegrations'
}

export enum UsersSubCategories {
    EXCLUDE_USERS = 'excludeUsers',
    DELETE_USER_TOKENS = 'deleteUserTokens',
    TEST_MFA_TOKENS = 'testMFATokens',
    SEND_ENROLLMENT_EMAIL = 'sendEnrollmentEmail',
    MANAGE_PROTECTED_GROUPS = 'manageProtectedGroups'
}

export enum SystemStatusSubCategories {
    TOGGLE_SYSTEM_POWER = 'toggleSystemPower',
    PREFORM_ADSYNC = 'preformAdsync'
}

export type AllPermissionsType = Pages | SettingsSubCategories | UsersSubCategories | SystemStatusSubCategories;

export type PermissionsRolesType = Record<AllPermissionsType, Roles>;
